import { Reveal, Overline } from "./primitives";

export const FiveHundred = () => (
  <section id="why-i-built-this" data-testid="fivehundred-section" className="relative overflow-hidden bg-ink py-24 text-center text-ivory md:py-32">
    <div className="grain-overlay opacity-[0.06]" />
    <div className="glow-float pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-terracotta/15 blur-[110px]" />
    <div className="relative mx-auto max-w-[860px] px-6 md:px-10">
      <Reveal><Overline className="text-terracotta">Why I Built This</Overline></Reveal>
      <Reveal delay={0.05}>
        <p className="mt-8 font-sans text-xl font-light leading-relaxed text-ivory/75 md:text-2xl">
          I asked 500 women what they wanted. They said:
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
          "More money. <span className="italic text-terracotta">More confidence.</span>"
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-8 max-w-xl font-display text-xl italic leading-snug text-ivory/85 md:text-2xl">
          This is the program I created to give them both.
        </p>
      </Reveal>
    </div>
  </section>
);
